import React from "react";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import ProcessTimeline from "@/components/sections/ProcessTimeline";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import { CTAButton } from "@/components/common/CTA";
import { ArrowRight } from "lucide-react";

export default function HowItWorks() {
  return (
    <>
      <SEO
        title="How It Works | Premier Global Sourcing"
        description="From requirement to delivery coordination: share your requirement, we review it, research options, coordinate and plan logistics with clear next steps."
        path="/how-it-works"
      />
      <PageHero
        eyebrow="How it works"
        title="From requirement to delivery coordination"
        intro="A clear, step-by-step path from your first requirement through sourcing, coordination and logistics planning."
        breadcrumbs={[{ label: "How It Works" }]}
      >
        <CTAButton to="/request-a-quote" variant="primary" icon={ArrowRight} data-testid="how-hero-cta">
          Start with your requirement
        </CTAButton>
      </PageHero>

      <ProcessTimeline chapter="" />
      <FAQ chapter="" />
      <FinalCTA />
    </>
  );
}
